import { NavLink, Route, Switch } from 'react-router-dom';
import React from 'react';

import Nav from '../../Nav';
import Billing from './Billing';
import AccountDetails from './AccountDetails';

function Account({ match: { path } }) {
    return (
        <>
            <Nav activeBorder>
                <div className="container">
                    <ul className="nav unstyle">
                        <li>
                            <NavLink exact to={path}>
                                Account Details
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={path + '/billing'}>
                                Plans & Billing
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink to={path + "/notification-settings"}>
                                Notification Settings
                            </NavLink>
                        </li> */}
                    </ul>
                </div>
            </Nav>
            <div style={{ marginTop: 40, paddingBottom: 40 }}>
                <Switch>
                    <Route exact path={path} component={AccountDetails} />
                    <Route exact path={path + '/billing'} component={Billing} />
                </Switch>
            </div>
        </>
    );
}

export default Account;
